import React from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import styled from "styled-components";
import "./footer.css";
import Image from "react-bootstrap/Image";

// Assets
import Logo from "../../../../assets/images/diarytree_logo25x25-cropped.svg";
import FacebookIcon from "../../../../assets/images/facebook_icon.svg";
import TwitterIcon from "../../../../assets/images/twitter_icon.svg";
import InstagramIcon from "../../../../assets/images/instagram_icon.svg";
import GooglePlayBtn from "../../../../assets/images/gplay_btn.svg";
import AppStoreBtn from "../../../../assets/images/appstore_btn.svg";

const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        const targetSection = document.getElementById(sectionId);
        if (targetSection) targetSection.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };

  return (
    <StyledFooter>
      <FooterInner className="section__padding">
        <FooterColumnsWrapper>
          <LogoColumn>
            <Link to="/" className="logo-link">
              <Image src={Logo} alt="Logo" />
              <span>diarytree</span>
            </Link>
            <Slogan>{t('HomePage.dashboardHeaderPresentation')}</Slogan>
          </LogoColumn>

          <LinksColumn>
            <h4>{t('HomePage.Footer_quickLinks')}</h4>
            <Link onClick={() => scrollToSection("about")}>{t('HomePage.Footer_about')}</Link>
            <Link onClick={() => scrollToSection("pricing")}>{t('HomePage.Footer_pricing')}</Link>
            <Link onClick={() => scrollToSection("contact")}>{t('HomePage.Footer_contact')}</Link>
          </LinksColumn>

          <LegalColumn>
            <h4>{t('HomePage.Footer_legal')}</h4>
            <Link onClick={() => scrollToSection("terms")}>{t('HomePage.Footer_terms')}</Link>
            <Link onClick={() => scrollToSection("privacy")}>{t('HomePage.Footer_privacy')}</Link>
            <Link onClick={() => scrollToSection("legal")}>{t('HomePage.Footer_legalMentions')}</Link>
          </LegalColumn>

          <SocialColumn>
            <h4>{t('HomePage.Footer_social')}</h4>
            <SocialIcons>
              <a href="https://facebook.com" target="_blank" rel="noreferrer">
                <img src={FacebookIcon} alt="Facebook" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer">
                <img src={TwitterIcon} alt="Twitter" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer">
                <img src={InstagramIcon} alt="Instagram" />
              </a>
            </SocialIcons>
          </SocialColumn>
          
          <DownloadColumn>
            <h4>{t('HomePage.Footer_downloadTitle')}</h4>
            <InfoP>{t('HomePage.Footer_downloadDescription')}</InfoP>
            <AppButtons>
              <a href="/" target="_blank" rel="noreferrer">
                <img src={GooglePlayBtn} alt="Google Play" />
              </a>
              <a href="/" target="_blank" rel="noreferrer">
                <img src={AppStoreBtn} alt="App Store" />
              </a>
            </AppButtons>
          </DownloadColumn>
        </FooterColumnsWrapper>

        <Copyright>
          <p>© {new Date().getFullYear()} diarytree.com.  {t('HomePage.Footer_rightReserved')}</p>
        </Copyright>
      </FooterInner>
    </StyledFooter>
  );
};

// Styled Components
const StyledFooter = styled.footer`
  background: #f8f9fa;
  padding: 50px 24px 0;
  border-top: 1px solid #eaeaea;
`;

const FooterInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 0;
`;

const FooterColumnsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr 1fr 1.8fr;
  gap: 20px;
  padding-bottom: 40px;

  @media (max-width: 992px) {
    grid-template-columns: 1fr 1fr;
    gap: 30px;
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const ColumnBase = styled.div`
  display: flex;
  flex-direction: column;
  
  h4 {
    font-size: 1.1rem;
    margin-bottom: 15px;
    color: #2d3748;
    font-weight: 600;
  }
  
  a {
    color: #4a5568;
    margin-bottom: 10px;
    font-size: 0.9rem;
    text-decoration: none;
    transition: color 0.3s;
    
    &:hover {
      color: #3182ce;
      text-decoration: underline;
    }
  }
`;

const LogoColumn = styled(ColumnBase)`
  .logo-link {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    
    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
    
    span {
      font-size: 1.1rem;
      color: #335c6e;
      font-weight: bold;
      vertical-align: middle;
    }
  }
`;

const Slogan = styled.p`
  font-size: 0.85rem;
  color: #4a5568;
  line-height: 1.5;
  margin-top: 5px;
`;

const LinksColumn = styled(ColumnBase)``;
const LegalColumn = styled(ColumnBase)``;
const SocialColumn = styled(ColumnBase)``;
const DownloadColumn = styled(ColumnBase)``;

const InfoP = styled.p`
  color: #4a5568;
  font-size: 0.85rem;
  margin: 5px 0 15px;
  line-height: 1.5;
`;

const AppButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  img {
    height: 36px;
    width: auto;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 15px;
  
  img {
    width: 24px;
    height: 24px;
    transition: transform 0.3s;
    
    &:hover {
      transform: translateY(-3px);
    }
  }
`;

const Copyright = styled.div`
  text-align: center;
  padding: 25px 0;
  border-top: 1px solid #e2e8f0;
  color: #718096;
  font-size: 0.9rem;
`;

export default Footer;
// import React from 'react';
// import { Link, useNavigate } from "react-router-dom";
// import { useTranslation } from 'react-i18next';
// import styled from "styled-components";
// import "./footer.css";
// import Image from "react-bootstrap/Image";

// // Assets
// import Logo from "../../../../assets/images/diarytree_logo25x25-cropped.svg";
// import FacebookIcon from "../../../../assets/images/facebook_icon.svg";
// import TwitterIcon from "../../../../assets/images/twitter_icon.svg";
// import InstagramIcon from "../../../../assets/images/instagram_icon.svg";
// import GooglePlayBtn from "../../../../assets/images/gplay_btn.svg";
// import AppStoreBtn from "../../../../assets/images/appstore_btn.svg";

// const Footer = () => {
//   const { t } = useTranslation();
//   const navigate = useNavigate();

//   const scrollToSection = (sectionId) => {
//     const section = document.getElementById(sectionId);
//     if (section) {
//       section.scrollIntoView({ behavior: "smooth" });
//     } else {
//       navigate("/");
//       setTimeout(() => {
//         const targetSection = document.getElementById(sectionId);
//         if (targetSection) targetSection.scrollIntoView({ behavior: "smooth" });
//       }, 100);
//     }
//   };

//   return (
//     <StyledFooter>
//       <FooterInner className="section__padding">
//         <FooterColumnsWrapper>
//           <LogoColumn>
//             <Link to="/">
//               <Image src={Logo} alt="Logo" />
//               <span>diarytree</span>
//             </Link>
//           </LogoColumn>

//           <LinksColumn>
//             <h4>{t('HomePage.Footer_quickLinks')}</h4>
//             <Link onClick={() => scrollToSection("about")}>{t('HomePage.Footer_about')}</Link>
//             <Link onClick={() => scrollToSection("pricing")}>{t('HomePage.Footer_pricing')}</Link>
//             <Link onClick={() => scrollToSection("contact")}>{t('HomePage.Footer_contact')}</Link>
//           </LinksColumn>

//           <LegalColumn>
//             <h4>{t('HomePage.Footer_legal')}</h4>
//             <Link onClick={() => scrollToSection("terms")}>{t('HomePage.Footer_terms')}</Link>
//             <Link onClick={() => scrollToSection("privacy")}>{t('HomePage.Footer_privacy')}</Link>
//             <Link onClick={() => scrollToSection("legal")}>{t('HomePage.Footer_legalMentions')}</Link>
//           </LegalColumn>

//           <SocialColumn>
//             <h4>{t('HomePage.Footer_social')}</h4>
//             <SocialIcons>
//               <a href="https://facebook.com" target="_blank" rel="noreferrer">
//                 <img src={FacebookIcon} alt="Facebook" />
//               </a>
//               <a href="https://twitter.com" target="_blank" rel="noreferrer">
//                 <img src={TwitterIcon} alt="Twitter" />
//               </a>
//               <a href="https://instagram.com" target="_blank" rel="noreferrer">
//                 <img src={InstagramIcon} alt="Instagram" />
//               </a>
//             </SocialIcons>
//           </SocialColumn>
          
//             <DownloadColumn>
//               <DownloadSection>
//                 <h4>{t('HomePage.Footer_downloadTitle')}</h4>
//                 <InfoP>{t('HomePage.Footer_downloadDescription')}</InfoP>
//                 <AppButtons>
//                   <a href="/" target="_blank" rel="noreferrer">
//                     <img src={GooglePlayBtn} alt="Google Play" />
//                   </a>
//                   <a href="/" target="_blank" rel="noreferrer">
//                     <img src={AppStoreBtn} alt="App Store" />
//                   </a>
//                 </AppButtons>
//               </DownloadSection>
//             </DownloadColumn>
//         </FooterColumnsWrapper>

//         <Copyright>
//           <p>© {new Date().getFullYear()} diarytree.com.  {t('HomePage.Footer_rightReserved')}</p>
//         </Copyright>
//       </FooterInner>
//     </StyledFooter>
//   );
// };

// const DownloadSection = styled.div`
//   margin-top: 25px;
// `;

// const InfoP = styled.p`
//   color: #4a5568;
//   font-size: 0.85rem;
//   margin: 10px 0 16px;
// `;

// const AppButtons = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 10px;

//   img {
//     height: 40px;
//     width: auto;
//   }
// `;
// // Styled Components
// const StyledFooter = styled.footer`
//   background: #f8f9fa;
//   padding: 50px 24px 0;
//   border-top: 1px solid #eaeaea;
// `;

// const FooterInner = styled.div`
//   max-width: 1200px;
//   margin: 0 auto;
//   padding-bottom: 0;
// `;

// const FooterColumnsWrapper = styled.div`
//   display: grid;
//   background-color:red;
//   grid-template-columns: 2fr 1fr 1fr 1fr;
//   gap: 30px;
//   padding-bottom: 40px;

//   @media (max-width: 768px) {
//     grid-template-columns: 1fr;
//   }
// `;

// const ColumnBase = styled.div`
//   display: flex;
//   flex-direction: column;
  
//   h4 {
//     font-size: 1.1rem;
//     margin-bottom: 20px;
//     color: #2d3748;
//     font-weight: 600;
//   }
  
//   a {
//     color: #4a5568;
//     margin-bottom: 12px;
//     font-size: 0.9rem;
//     text-decoration: none;
//     transition: color 0.3s;
    
//     &:hover {
//       color: #3182ce;
//       text-decoration: underline;
//     }
//   }
// `;

// const LogoColumn = styled(ColumnBase)`
//   img {
//     width: 30px;
//     height: 30px;
//     margin-right: 10px;
//   }
  
//   span {
//     font-size: 1.2rem;
//     color: #335c6e;
//     font-weight: bold;
//     vertical-align: middle;
//   }
  
//   a {
//     display: flex;
//     align-items: center;
//     margin-bottom: 20px;
//   }
// `;

// const LinksColumn = styled(ColumnBase)``;
// const LegalColumn = styled(ColumnBase)``;

// const SocialColumn = styled(ColumnBase)`
//   h4 {
//     margin-bottom: 15px;
//   }
// `;

// const DownloadColumn = styled(ColumnBase)``;

// const SocialIcons = styled.div`
//   display: flex;
//   gap: 15px;
  
//   img {
//     width: 24px;
//     height: 24px;
//     transition: transform 0.3s;
    
//     &:hover {
//       transform: translateY(-3px);
//     }
//   }
// `;

// const Copyright = styled.div`
//   text-align: center;
//   padding: 25px 0;
//   border-top: 1px solid #e2e8f0;
//   color: #718096;
//   font-size: 0.9rem;
// `;


// export default Footer;

// import React from 'react';
// import { Link, useNavigate } from "react-router-dom";
// import { useTranslation } from 'react-i18next';
// import styled from "styled-components";
// import "./footer.css";
// import Image from "react-bootstrap/Image";

// // Assets
// import Logo from "../../../../assets/images/diarytree_logo25x25-cropped.svg";
// import FacebookIcon from "../../../../assets/images/facebook_icon.svg";
// import TwitterIcon from "../../../../assets/images/twitter_icon.svg";
// import InstagramIcon from "../../../../assets/images/instagram_icon.svg";

// const Footer = () => {
//   const { t } = useTranslation();
//   const navigate = useNavigate();

//   const scrollToSection = (sectionId) => {
//     const section = document.getElementById(sectionId);
//     if (section) {
//       section.scrollIntoView({ behavior: "smooth" });
//     } else {
//       navigate("/");
//       setTimeout(() => {
//         const targetSection = document.getElementById(sectionId);
//         if (targetSection) targetSection.scrollIntoView({ behavior: "smooth" });
//       }, 100);
//     }
//   };

//   return (
//     <StyledFooter className="dtree_footer">
//       <FooterInner className="dtree_footer section__padding">
//         <FooterColumnsWrapper>
//           <LogoColumn>
//             <Link to="/">
//               <Image src={Logo} alt="Logo" />
//               <span>diarytree</span>
//             </Link>
//           </LogoColumn>

//           <LinksColumn>
//             <h4>{t('HomePage.Footer_quickLinks')}</h4>
//             <Link onClick={() => scrollToSection("about")}>{t('HomePage.Footer_about')}</Link>
//             <Link onClick={() => scrollToSection("pricing")}>{t('HomePage.Footer_pricing')}</Link>
//             <Link onClick={() => scrollToSection("contact")}>{t('HomePage.Footer_contact')}</Link>
//           </LinksColumn>

//           <LegalColumn>
//             <h4>{t('HomePage.Footer_legal')}</h4>
//             <Link onClick={() => scrollToSection("terms")}>{t('HomePage.Footer_terms')}</Link>
//             <Link onClick={() => scrollToSection("privacy")}>{t('HomePage.Footer_privacy')}</Link>
//             <Link onClick={() => scrollToSection("legal")}>{t('HomePage.Footer_legalMentions')}</Link>
//           </LegalColumn>

//           <SocialColumn>
//             <h4>{t('HomePage.Footer_social')}</h4>
//             <SocialIcons>
//               <a href="https://facebook.com" target="_blank" rel="noreferrer">
//                 <img src={FacebookIcon} alt="Facebook" />
//               </a>
//               <a href="https://twitter.com" target="_blank" rel="noreferrer">
//                 <img src={TwitterIcon} alt="Twitter" />
//               </a>
//               <a href="https://instagram.com" target="_blank" rel="noreferrer">
//                 <img src={InstagramIcon} alt="Instagram" />
//               </a>
//             </SocialIcons>
//                        <div className="dtree_footer-links_div">
//              <h4>Download our app</h4>
//              <InfoP>Get the best experience by downloading our app from the Play Store or App Store.</InfoP>
//              <Separator/><Separator/>
//              <AppLink to="/">
//              <img src={GooglePlayBtn} alt="diary tree google play" />
//              </AppLink>
//              <AppLink to="/">
//              <Separator />
//              <img src={AppStoreBtn} alt="diary tree app store" />
//              </AppLink>
//            </div>   
//           </SocialColumn>
//         </FooterColumnsWrapper>

//         <Copyright>
//           <p>© {new Date().getFullYear()} Évrit. {t('HomePage.Footer_rightReserved')}</p>
//         </Copyright>
//       </FooterInner>
//     </StyledFooter>
//   );
// };

// // Styled Components
// const StyledFooter = styled.footer`
//   background: #f8f9fa;
//   padding: 50px 24px 0;
//   border-top: 1px solid #eaeaea;
// `;

// const FooterInner = styled.div`
//   max-width: 1200px;
//   margin: 0 auto;
//   padding-bottom: 0;
// `;

// const FooterColumnsWrapper = styled.div`
//   display: grid;
//   grid-template-columns: 2fr 1fr 1fr 1fr;
//   gap: 30px;
//   padding-bottom: 40px;

//   @media (max-width: 768px) {
//     grid-template-columns: 1fr;
//   }
// `;

// const ColumnBase = styled.div`
//   display: flex;
//   flex-direction: column;
  
//   h4 {
//     font-size: 1.1rem;
//     margin-bottom: 20px;
//     color: #2d3748;
//     font-weight: 600;
//   }
  
//   a {
//     color: #4a5568;
//     margin-bottom: 12px;
//     font-size: 0.9rem;
//     text-decoration: none;
//     transition: color 0.3s;
    
//     &:hover {
//       color: #3182ce;
//       text-decoration: underline;
//     }
//   }
// `;

// const LogoColumn = styled(ColumnBase)`
//   img {
//     width: 30px;
//     height: 30px;
//     margin-right: 10px;
//   }
  
//   span {
//     font-size: 1.2rem;
//     color: #335c6e;
//     font-weight: bold;
//     vertical-align: middle;
//   }
  
//   a {
//     display: flex;
//     align-items: center;
//     margin-bottom: 20px;
//   }
// `;

// const LinksColumn = styled(ColumnBase)``;
// const LegalColumn = styled(ColumnBase)``;

// const SocialColumn = styled(ColumnBase)`
//   h4 {
//     margin-bottom: 15px;
//   }
// `;

// const SocialIcons = styled.div`
//   display: flex;
//   gap: 15px;
  
//   img {
//     width: 24px;
//     height: 24px;
//     transition: transform 0.3s;
    
//     &:hover {
//       transform: translateY(-3px);
//     }
//   }
// `;

// const Copyright = styled.div`
//   text-align: center;
//   padding: 25px 0;
//   border-top: 1px solid #e2e8f0;
//   color: #718096;
//   font-size: 0.9rem;
// `;

// export default Footer;


// import React,{useState,useEffect} from 'react';
// // import Logo from "../../assets/images/logo_transparent.png";

// import Logo from "../../../../assets/images/diarytree_logo25x25-cropped.svg"; // Tell webpack this JS file uses this image
// import "./footer.css";
// import {  useNavigate,Link } from "react-router-dom";
// import { useTranslation } from 'react-i18next';
// import Image from "react-bootstrap/Image";
// import styled from "styled-components";
// import GooglePlayBtn from "../../../../assets/images/gplay_btn.svg";
// import AppStoreBtn from "../../../../assets/images/appstore_btn.svg";
// import {Select,MenuItem } from '@mui/material';



// const Footer = () => {
//   const navigate = useNavigate();
//   const { t,i18n } = useTranslation();


//     return (
//   <StyledFooter className="dtree_footer">
//     <FooterInner className="dtree_footer section__padding">
//       <FooterColumnsWrapper className="dtree_footer-links">
//         <LogoColumn className="dtree_footer-links_logo">
//           {/* <img src={gpt3Logo} alt="dtreelogo" />
//            */}
//           <Link to="/" >
//             <Image src={Logo} style={{ width: "2em" }} alt="Logo" />
//             <span style={{ marginLeft: '0.5em', fontSize: '1em', color: '#335c6e',  fontWeight: 'bold',fontStyle:'unset' }}>diarytree</span>
//           </Link>
//           <InfoP>
//             Search amazing services around the globe, find one and use its
//             services
//           </InfoP>
//           <EmailP>contact@diarytree.com</EmailP>
//           <AddressP>Crechterwoord K12 182 DK Alknjkcb</AddressP>
//           <AddressP>085-132567</AddressP>
//           <AddressP>info@payme.net</AddressP>
//         </LogoColumn>
//         <RightSide>
//           <div className="dtree_footer-links_div">
//             <h4>Links</h4>
//             <LinkColumn>Overons</LinkColumn>
//             <LinkColumn>Social Media</LinkColumn>
//             <LinkColumn>Counters</LinkColumn>
//             <LinkColumn>Contact</LinkColumn>
//           </div>
//           <div className="dtree_footer-links_div">
//             <h4>Company</h4>
//             <LinkColumn>Terms & Conditions </LinkColumn>
//             <LinkColumn>Privacy Policy</LinkColumn>
//             <LinkColumn>Contact</LinkColumn>
//           </div>
//           <div className="dtree_footer-links_div">
//             <h4>Download our app</h4>
//             <InfoP>Get the best experience by downloading our app from the Play Store or App Store.</InfoP>
//             <Separator/><Separator/>
//             <AppLink to="/">
//             <img src={GooglePlayBtn} alt="diary tree google play" />
//             </AppLink>
//             <AppLink to="/">
//             <Separator />
//             <img src={AppStoreBtn} alt="diary tree app store" />
//             </AppLink>
//           </div>         
//         </RightSide>
//       </FooterColumnsWrapper>

//       <Copyright>
//       <p>&copy; {new Date().getFullYear()} diarytree.com. {t('HomePage.Footer_rightReserved')}.</p>
//       </Copyright>
//     </FooterInner>
//   </StyledFooter>
// )

// };
// const Separator = styled.div`
//   height: 10px
// `;

// const AppLink = styled(Link)`
//   object-fit: contain;
// `;

// const FooterColumnsWrapper = styled.div`
//   @media (max-width: 768px) {
//      flex-direction: column;
//   }
// `
// const StyledFooter = styled.footer`
//   background: rgba(244, 249, 255, 0.8);
//   padding-top: 50px;
//   padding-bottom: 0;
//   padding-left: 24px;
//   padding-right: 24px;
// `;

// const FooterInner = styled.div`
//   max-width: 1200px;
//   width: 100%;
//   display: flex;
//   padding-bottom: 0;
// `;

// const LogoColumn = styled.div`
//   width: 370px;
//   padding-right: 100px;
//   @media (max-width: 900px) {
//       width: 280px;
//       padding-right: 30px;
//   }
// `;
// const RightSide = styled.div`
//   display: flex;
//   flex: 1;
//   justify-content: space-between;
//   @media (max-width: 768px) {
//       padding-top: 30px;
//       flex-direction: column;
//       h4 {
//         padding-top: 30px;
//       }
//   }
// `;
// const LinkColumn = styled.div`
//   font-size: 0.9rem;
//   line-height: 2rem;
// `;
// const InfoP = styled.p`
//   font-size: 13px;
//   line-height: 22px;
// `;
// const EmailP = styled.p`
//   font-size: 20px;
//   margin-top: 20px;
//   color: #111 !important;
// `;

// const AddressP = styled.p`
//   font-size: 0.9rem;
//   color: #5e5e5e;
// `;

// const Copyright = styled.div`
//   margin-top: 40px;
//   padding: 25px 0;
//   border-top: 1px solid #ccc;
//   display: flex;
//   width: 100%;
//   justify-content: center;
// `;

// export default Footer;
